import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle, useMemo,
  useRef,
  useState,
} from "react";
import TextField from "@mui/material/TextField";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormPageHeader from "../utilities/FormPageHeader";
import {
  FormControlLabel,
  Switch,
  Stack,
  Box,
  Autocomplete,
  createFilterOptions,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Button,
} from "@mui/material";
import Select from "react-select";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import * as Flags from "country-flag-icons/react/3x2";
import VendorDiscountData from "./DiscountData";
import CustomerDiscountData from "../customers/tabs/DiscountData";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import AgGridTable from "../utilities/AgGridTable";
import customSelectStyles from "app/shared-components/SelectCustomStyle";
import { toast } from "react-toastify";
const routingOptions = [
  { value: "BookingRequest", label: "Booking Request" },
  { value: "ReleaseRequest", label: "Release Request" },
  { value: "PartOrder", label: "Part Order" },
  { value: "ABConfirmation", label: "AB Confirmation" },
  { value: "Pending AB Report", label: "Pending AB Report" },
];

const FactoryVendorForm = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
  const userURL = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
  const [tabValue, setTabValue] = useState(0);
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [countryOptions, setCountryOptions] = useState();
  const [citiOptions, setCitiOptions] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [hideButton, setHideButton] = useState(false);
  const [saveDisable, setSaveDisable] = useState(true);
  const [isNum, setIsNum] = useState(true);
  const [isBrFrom, setIsBrFrom] = useState(true);
  const [isBrTo, setIsBrTo] = useState(true);
  const [isBrCc, setIsBrCc] = useState(true);
  const [isRrFrom, setIsRrFrom] = useState(true);
  const [userLists, setUserLists] = useState();
  const [isRrTo, setIsRrTo] = useState(true);
  const [isRrCc, setIsRrCc] = useState(true);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [editData, setEditData] = useState();
  const [cityLink, setCityLink] = useState();
  const filter = createFilterOptions();
  const gridRef = useRef();
  const [savedEmailRouting,setSavedEmailRouting]=useState([])
  const [emailRoutingOption,setEmailRoutingOption]=useState(routingOptions)
  const [allUserList, setAllUserList] = useState([]);
  const EmailRoutingDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState("");

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData( data);
      setValue( value);
      setEmailRoutingData(prev => ([...prev].map(item => {
        if (item.id === data.id) {
          return {
            ...item,
            emailRouting: value?.label
          }
        } else {
          return {...item}
        }
      })))
      setSavedEmailRouting(pre=>([...pre]?.map(item=>{
        if (item.id === data.id) {
          return {
            ...data
          }
        } else {
          return {...item}
        }
      })))
      setSelectedEmailRows([])
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if(data?.emailRouting){
        setValue(routingOptions?.filter((item)=>item?.label?.toUpperCase() === data?.emailRouting?.toUpperCase())[0])
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Select
          name="emailRouting"
          value={value}
          ref={refEmailRouting}
          onChange={handleCountryChange}
          className="select"
          classNamePrefix="select"
          options={props?.options}
          styles={customSelectStyles()}
          // isClearable
        />
      </div>
    );
  });
  const EmailFromDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState(null);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if(data){
        const oldValue=props?.userData?.filter((item)=>item?.label === data?.from)[0]
        if(oldValue){
        setValue(oldValue)
        }else{
          if(data.from){
            setValue({ label: data?.from, value: data?.from })
          }
        }
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth
    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"from"}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable
            options={props?.userData}
            value={value}
            onChange={(e,newValue)=>{
              if(newValue){
                setValue(newValue)
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      from:newValue?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }

            }}
            onInputChange={(e,newValue)=>{
                setValue({
                  label: newValue,
                  value: newValue,
                });
            }}
            onBlur={(e)=>{
              setValue({
                label: e?.target?.value,
                value: e?.target?.value,
              });
              setEmailRoutingData(prev => ([...prev]?.map(item => {
                if (item.id === data.id) {
                  return {
                    ...item,
                    from:e?.target?.value
                  }
                } else {
                  return {...item}
                }
              })))
              setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                if (item.id === data.id) {
                  return {
                    ...data
                  }
                } else {
                  return {...item}
                }
              })))
              setSelectedEmailRows([])
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });
  const EmailToDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState([]);

    useEffect(() => {
      if(data.to){
        const list=data?.to
        let newData=[]
        list.forEach(item=>{
          if(item){
            newData.push({label:item,value:item})
          }
        })
        setValue(newData)
      }
    }, [data]);
    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.map((data) => data.label);
        },
      };
    });
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth
    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"to"}
            multiple={true}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable
            options={props?.userData}
            value={value}
            filterSelectedOptions
            onChange={(e,newValue)=>{
              if(newValue){
                setValue(newValue)
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      to:[...newValue?.map((item)=>item?.label)]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      to:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            onBlur={(e,newValue)=>{
              const values=e?.target?.value
              if(values){
                setValue((pre)=>([...pre,{ label:values, value:values }]))
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      to:[...value?.map((item)=>item?.label),values]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      to:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }else{
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      to:[...value?.map(item=>item?.label)],
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      to:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            filterOptions={(options, params) => {
              const  filterOptions= filter(options, params);

              const { inputValue } = params;
              const filtered=filterOptions.filter((item=>!value.some(fItem=>fItem.label === item.label)))

              if (options.length > 0) {
                const isExisting = options.some(
                    (option) => inputValue === option.label
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({label:`${inputValue}`,inputValue});
                }
              }

              return filtered;
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });
  const EmailCcDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState([]);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.map((data) => data.label);
        },
      };
    });

    useEffect(() => {
      if(data.cc){
        const list=data?.cc
        let newData=[]
        list?.forEach(item=>{
          if(item){
            newData.push({label:item,value:item})
          }
        })
        setValue(newData)
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"cc"}
            multiple={true}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable
            options={props?.userData}
            value={value}
            filterSelectedOptions
            onChange={(e,newValue)=>{
              if(newValue){
                setValue(newValue)
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      cc:[...newValue?.map(item=>item?.label)]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      cc:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            onBlur={(e,newValue)=>{
              const values=e?.target?.value
              if(values){
                setValue((pre)=>([...pre,{ label: values, value: values }]))
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      cc:[...value?.map((item)=>item?.label),values]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      cc:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }else{
                setEmailRoutingData(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      cc:[...value?.map(item=>item?.label)]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data,
                      cc:props?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            filterOptions={(options, params) => {
              const  filterOptions= filter(options, params);

              const { inputValue } = params;
              const filtered=filterOptions.filter((item=>!value.some(fItem=>fItem.label === item.label)))

              if (options.length > 0) {
                const isExisting = options.some(
                    (option) => inputValue === option.label
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({label:`${inputValue}`,inputValue});
                }
              }

              return filtered;
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });
  const SubjectRef=forwardRef((props, ref)=>{
    const { data, colDef, node } = props;
    const [value, setValue] = useState("");
    const refSubject = useRef();

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });
    useEffect(() => {
      if(data){
        setValue(data?.subject)
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth
    return(
        <div className="w-full" style={{width:selectWidth}}>
        <TextField
            ref={refSubject}
            value={value}
            // onChange={subjectHandler}
            fullWidth={true}
            autoFocus={true}
            onChange={(e)=>{
                setValue(e.target.value)
                props?.node?.setData(data)
            }}
            onBlur={(e) => {
              if (!e.target.value) return;
              setEmailRoutingData(prev => ([...prev].map(item => item.id === data.id ? ({...item,subject:e?.target?.value}) : ({...item}))))
              setSavedEmailRouting(prev => ([...prev].map(item => item.id === data.id ? ({...data,subject:props?.value}) : ({...item}))))
              setSelectedEmailRows([])
            }}
        />
        </div>
    )
  })
  const [selectedEmailRows, setSelectedEmailRows] = useState([]);
  const [column, setColumn] = useState([
    {
      field: "emailRouting",
      headerName: "*Email Routing",
      cellEditorPopup: true,
      cellEditor: EmailRoutingDropdown,
      cellEditorParams:{
        options:emailRoutingOption
      }
    },
    {
      field: "subject",
      headerName: "*Subject",
      cellEditorPopup: true,
      cellEditor: SubjectRef,
    },
    {
      field: "from",
      cellEditorPopup: true,
      cellEditor: EmailFromDropdown,
      headerName: "*From",
      cellEditorParams:{
        userData:allUserList
      }
    },
    {
      field: "to",
      cellEditorPopup: true,
      cellEditor: EmailToDropdown,
      headerName: "*To",
      cellEditorParams:{
        userData:allUserList
      }
    },
    {
      field: "cc",
      headerName: "*CC",
      cellEditorPopup: true,
      cellEditor: EmailCcDropdown,
      cellEditorParams:{
        userData:allUserList
      }
    },
  ]);
  const params = useParams();
  const location = useLocation();
  const [emailRoutingData, setEmailRoutingData] = useState([]);
  const [vendorData, setVendorData] = useState({
    vendorNumber: "",
    name: "",
    shortKey: "",
    active: false,
    id: "",
    tag: "",
    address1: "",
    address2: "",
    poBox: "",
    city: "",
    country: "",
    currencyCode: "",
    brMailSubject: "",
    brMailFrom: "",
    brMailTo: [],
    brMailCc: [],
    rrMailSubject: "",
    rrMailFrom: "",
    rrMailTo: [],
    rrMailCc: [],
  });
  const onEmailSelectionChanged = (params) => {
    setSelectedEmailRows(params.api.getSelectedRows());
  };

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          setHideDelete(false);
          const result = await OAuthService.getEditData(url, id);
          const vendorDetail = result?.data;
          let newData = [];
          vendorDetail.emailRoutings?.map((item, index) => {
            let keyMCC = [];
            let keyCc = item?.cc?.map((val) => {
              if (val.includes(",")) {
                const array = val.split(",");
                array.map((arr, index) => {
                  if (index === 0) {
                    val = arr;
                  } else {
                    keyMCC.push(arr);
                  }
                });
              }
              return val;
            });
            keyCc = [...keyCc, ...keyMCC];
            let ketMTO = [];
            let keyTO = item?.to.map((val) => {
              if (val.includes(",")) {
                const array = val.split(",");
                array.map((arr, index) => {
                  if (index === 0) {
                    val = arr;
                  } else {
                    ketMTO.push(arr);
                  }
                });
              }
              return val;
            });
            keyTO = [...keyTO, ...ketMTO];
            newData.push({
              ...item,
              to: keyTO,
              cc: keyCc,
              id: index + 1,
              subject: item.subject || null,
            });
          });
          setEmailRoutingData((pre) => [...pre, ...newData]);
          setSavedEmailRouting((pre) => [...pre, ...newData])
          const address = vendorDetail.defaultAddress;
          const mailDetails = vendorDetail.mailConfig;
          const brMail = mailDetails.BR_MAIL;
          const rrMail = mailDetails.RR_MAIL;
          const brMailSubject = brMail?.subject;
          const rrMailSubject = rrMail?.subject;
          let externalbrto = [];
          let brMailto = brMail?.mailTo.map((val) => {
            if (val.includes(",")) {
              const array = val.split(",");
              array.map((arr, index) => {
                if (index === 0) {
                  val = arr;
                } else {
                  externalbrto.push(arr);
                }
              });
            }
            return val;
          });
          brMailto = [...brMailto, ...externalbrto];
          let externalbrcc = [];
          let brMailCc = brMail?.mailCC.map((val) => {
            if (val.includes(",")) {
              const array = val.split(",");
              array.map((arr, index) => {
                if (index === 0) {
                  val = arr;
                } else {
                  externalbrcc.push(arr);
                }
              });
            }
            return val;
          });
          brMailCc = [...brMailCc, ...externalbrcc];
          let externalrrto = [];
          let rrMailto = rrMail?.mailTo.map((val) => {
            if (val.includes(",")) {
              const array = val.split(",");
              array.map((arr, index) => {
                if (index === 0) {
                  val = arr;
                } else {
                  externalrrto.push(arr);
                }
              });
            }
            return val;
          });
          rrMailto = [...rrMailto, ...externalrrto];
          let externalrrcc = [];
          let rrMailCc = rrMail?.mailCC.map((val) => {
            if (val.includes(",")) {
              const array = val.split(",");
              array.map((arr, index) => {
                if (index === 0) {
                  val = arr;
                } else {
                  externalrrcc.push(arr);
                }
              });
            }
            return val;
          });
          rrMailCc = [...rrMailCc, ...externalrrcc];
          // setEmailRoutingData((pre) => [
          //   ...pre,
          //   {
          //     ...brMail,
          //     mailCC: brMailCc,
          //     mailTo: brMailto,
          //   },
          // ]);
          setVendorData({
            vendorNumber: vendorDetail.id,
            name: vendorDetail.name,
            shortKey: vendorDetail.shortKey,
            active: vendorDetail.active,
            id: address?.id,
            tag: address?.tag,
            address1: address?.address1,
            address2: address?.address2,
            city: address?.city,
            poBox: address?.poBox,
            country: address?.country,
            currencyCode: vendorDetail.currencyCode,
            brMailFrom: brMail?.mailFrom,
            brMailSubject: brMailSubject,
            rrMailSubject: rrMailSubject,
            brMailTo: brMailto,
            brMailCc: brMailCc,
            rrMailFrom: rrMail?.mailFrom,
            rrMailTo: rrMailto,
            rrMailCc: rrMailCc,
          });
          setEditData({
            vendorNumber: vendorDetail.id,
            name: vendorDetail.name,
            shortKey: vendorDetail.shortKey,
            active: vendorDetail.active,
            id: address?.id,
            tag: address?.tag,
            address1: address?.address1,
            address2: address?.address2,
            city: address?.city,
            poBox: address?.poBox,
            country: address?.country,
            currencyCode: vendorDetail.currencyCode,
            brMailFrom: brMail?.mailFrom,
            brMailTo: brMailto,
            brMailSubject: brMailSubject,
            rrMailSubject: rrMailSubject,
            brMailCc: brMailCc,
            rrMailFrom: rrMail?.mailFrom,
            rrMailTo: rrMailto,
            rrMailCc: rrMailCc,
          });
        }
      } catch (e) {
        setError(e);
      }
    })();
  }, []);
  useEffect(() => {
    const country = async () => {
      const countryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
      const countries = await OAuthService.getList(countryURL + "?size=1000");

      const result = countries?.data?._embedded.countries.map((value) => {
        const Flag = Flags[value?.isoCode];
        let city_link = value._links.cities.href;
        return {
          label: value?.name,
          city_link: city_link,
          value: value?.name,
          code: value?.isoCode,
          icon: value?.isoCode && (
            <Flag width={18} style={{ marginInline: "5px" }} />
          ),
        };
      });
      setCountryOptions(result);
    };
    country();

    const users = async () => {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
      const user = await OAuthService.getList(url);
      const list = user?.data?._embedded?.users.map((data, index) => {
        data.name =
          data?.firstName +
          " " +
          (data?.middleName !== null ? data?.middleName + " " : "") +
          data?.lastName;
        return data.email;
      });
      setUserLists(list);
    };
    users();
  }, []);

useEffect(() => {
  const fetchCities = async () => {
    try {
      if (vendorData?.country && countryOptions?.length) {

        const country = countryOptions.find(
          (c) => c.value === vendorData.country
        );

        if (!country?.city_link) return;

        const response = await OAuthService.getList(
          `${country.city_link}?size=1000`
        );

        const cityList =
          response?.data?._embedded?.cities?.map((item) => ({
            value: item.cityName
          })) || [];

        setCitiOptions(cityList);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  fetchCities();
}, [vendorData, countryOptions]);

  const changeHandlerCountry = async (data, action) => {
    setVendorData({
      ...vendorData,
      country: action.action === "clear" ? "" : data.value,
    });
  };
  const changeHandlerCity = (data, action) => {
    setVendorData({
      ...vendorData,
      city: action.action === "clear" ? "" : data.value,
    });
  };
  const onChangeHandleInput = (e, value) => {
    const name = e.target.name;
    if (name == "active") {
      setVendorData({ ...vendorData, [name]: e.target.checked });
    } else
      setVendorData({
        ...vendorData,
        [name]: e.target.value.toUpperCase() || e.target.innerHTML,
      });
  };

  function handleTabChange(event, value) {
    setTabValue(value);
  }

  const handleDelete = async () => {
    if (id) {
      try {
        await OAuthService.deleteData(url, id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
        setTimeout(() => {
          navigate("/factoryVendors");
        }, 800);
      } catch (error) {
        console.log("eror", error);
        setError(error.message);
      }
    }
  };

  let numReg = new RegExp("^[0-9]+$");

  const handleSubmit = async () => {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (numReg.test(vendorData.vendorNumber.toString())) setIsNum(true);
    else {
      setTabValue(0);
      return setIsNum(false);
    }

    if (vendorData.brMailFrom.toString().trim().match(mailformat))
      setIsBrFrom(true);
    else {
      setTabValue(1);
      return setIsBrFrom(false);
    }

    if (vendorData.rrMailFrom.toString().trim().match(mailformat))
      setIsRrFrom(true);
    else {
      setTabValue(1);
      return setIsRrFrom(false);
    }

    if (vendorData.brMailTo.length > 0) {
      for (let i in vendorData.brMailTo) {
        if (vendorData.brMailTo[i].toString().trim().match(mailformat))
          setIsBrTo(true);
        else {
          setTabValue(1);
          return setIsBrTo(false);
        }
      }
    }

    if (vendorData.brMailCc.length > 0) {
      const brmailcc = vendorData.brMailCc;
      for (let i in brmailcc) {
        if (brmailcc[i].toString().trim().match(mailformat)) setIsBrCc(true);
        else {
          setTabValue(1);
          return setIsBrCc(false);
        }
      }
    }
    if (vendorData.rrMailTo.length > 0) {
      const rrmailto = vendorData.rrMailTo;
      for (let i in rrmailto) {
        if (rrmailto[i].toString().trim().match(mailformat)) setIsRrTo(true);
        else {
          setTabValue(1);
          return setIsRrTo(false);
        }
      }
    }
    if (vendorData.rrMailCc.length > 0) {
      const rrmailcc = vendorData.rrMailCc;
      for (let i in rrmailcc) {
        if (rrmailcc[i].toString().trim().match(mailformat)) setIsRrCc(true);
        else {
          setTabValue(1);
          return setIsRrCc(false);
        }
      }
    }

    setCheckSubmit(true);
    let model = {
      id: vendorData.vendorNumber,
      name: vendorData.name,
      shortKey: vendorData.shortKey,
      active: vendorData.active,
      defaultAddress: {
        id: vendorData?.id,
        tag: vendorData?.tag,
        address1: vendorData?.address1,
        address2: vendorData?.address2,
        city: vendorData?.city,
        poBox: vendorData?.poBox,
        country: vendorData?.country,
      },
      currencyCode: vendorData.currencyCode,
      mailConfig: {
        BR_MAIL: {
          id: "",
          mailFrom: vendorData.brMailFrom,
          mailTo: vendorData.brMailTo,
          mailCC: vendorData.brMailCc,
          subject: vendorData.brMailSubject,
        },
        RR_MAIL: {
          id: "",
          mailFrom: vendorData.rrMailFrom,
          mailTo: vendorData.rrMailTo,
          mailCC: vendorData.rrMailCc,
          subject: vendorData.rrMailSubject,
        },
      },
    };

    try {
      if (id) {
        if (
          vendorData?.vendorNumber &&
          vendorData?.name &&
          vendorData?.shortKey &&
          isNum &&
          vendorData?.brMailTo.length > 0 &&
          vendorData?.brMailFrom &&
          vendorData?.brMailCc.length > 0 &&
          vendorData?.rrMailFrom &&
          vendorData?.rrMailTo.length > 0 &&
          vendorData?.rrMailCc.length > 0
        ) {
          await OAuthService.updateData(url, id, model);
          setSuccessMsg("Data Updated Successfully");
          setSnackState(true);
          setTimeout(() => {
            navigate("/factoryVendors");
          }, 800);
        }
      } else {
        if (
          vendorData?.vendorNumber &&
          vendorData?.name &&
          vendorData?.shortKey &&
          isNum &&
          vendorData?.brMailTo.length > 0 &&
          vendorData?.brMailFrom &&
          vendorData?.brMailCc.length > 0 &&
          vendorData?.rrMailFrom &&
          vendorData?.rrMailTo.length > 0 &&
          vendorData?.rrMailCc.length > 0
        ) {
          await OAuthService.addData(url, model);
          setSuccessMsg("Data saved Successfully");
          setSnackState(true);
          setTimeout(() => {
            navigate("/factoryVendors");
          }, 800);
        }
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
      return;
    }
  };

  const customStyles = (color) => {
    return {
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: isFocused ? "gray" : "black",
          color: "white",
        };
      },
      control: (styles, { isDisabled }) => ({
        ...styles,
        backgroundColor: null,
        // borderColor: color,
        padding: "7.5px 7px",
        // opacity: isDisabled ? 0.5 : 1
      }),
      singleValue: (styles, { data }) => ({
        ...styles,
        color: "white",
        alignItems: "center",
        // display: 'flex',
      }),
      menuList: (base) => ({
        ...base,
        padding: 0,
        background: "black",
      }),
      menu: (styles) => ({ ...styles, zIndex: 999 }),
    };
  };

  const handleCancel = () => {
    navigate("/factoryVendors");
  };

  useEffect(() => {
    if (
      vendorData.name &&
      vendorData.shortKey &&
      vendorData.brMailFrom &&
      vendorData.brMailTo.length > 0 &&
      vendorData.brMailSubject &&
      vendorData.brMailCc.length > 0 &&
      vendorData.rrMailCc.length > 0 &&
      vendorData.rrMailFrom &&
      vendorData.rrMailTo.length > 0 &&
      vendorData.rrMailSubject
    ) {
      if (editData) {
        if (JSON.stringify(editData) !== JSON.stringify(vendorData)) {
          setSaveDisable(false);
        } else {
          setSaveDisable(true);
        }
      } else {
        setSaveDisable(false);
      }
    } else {
      setSaveDisable(true);
    }
  }, [vendorData]);

  const setAllSuccessMsg = (msg) => {
    if (msg) {
      setSuccessMsg(msg);
      setSnackState(true);
    }
  };
  const setAllErrorMsg = (msg) => {
    setError(msg);
  };
  const getUserList = async () => {
    const userData = await OAuthService.getList(userURL);
    setAllUserList(
        userData?.data?._embedded?.users?.map((option) => {
          return { value: option.email, label: option.email };
        })
    );
  };
  useEffect(() => {
    setAllSuccessMsg();
    setAllErrorMsg();
    getUserList()
  }, []);

  useEffect(() => {
    const getNextSeqOfNum = async () => {
      if (!id) {
        try {
          const vendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendors}/nextSeqNumOfFactoryVendor`;
          const nextSeqNumOfCompany = await OAuthService.getList(vendorUrl);
          setVendorData({
            ...vendorData,
            vendorNumber: nextSeqNumOfCompany.data,
          });
        } catch (error) {
          console.log(error);
        }
      }
    };
    getNextSeqOfNum();
  }, []);
  useEffect(() => {
    const selectedRoutes=emailRoutingData?.map((item)=>item?.emailRouting)
    if(selectedRoutes){
      const check= routingOptions.filter(
          (item) =>
              !selectedRoutes?.some((ftItem) => ftItem?.toUpperCase()?.toString() === item.label?.toUpperCase()?.toString())
      )
      setEmailRoutingOption(check)
    }
  }, [selectedEmailRows,emailRoutingData]);
useEffect(() => {
 if (tabValue===2){
  setHideButton(true)
 }else{
  setHideButton(false)
 }
}, [tabValue])

  useEffect(()=>{
    if(emailRoutingOption){
      const clone=[...column]
      clone?.map((item)=>{
        if(item?.field === "emailRouting"){
          return item.cellEditorParams.options=emailRoutingOption
        }
      })
      setColumn(clone)
    }
    if(allUserList){
      const clone=[...column]
      clone?.map((item)=>{
        if(item.field === "from" || item.field === "to"  || item.field === "cc"  ){
          return item.cellEditorParams.userData=allUserList
        }
      })
      setColumn(clone)
    }
  },[emailRoutingOption,allUserList])
  const matchTwoArray=(a,b)=>{
    return a?.length === b?.length &&
        a?.every(
            (e1)=>
            b?.some(
                (e2)=>
                    e1?.emailRouting === e2?.emailRouting &&
                    e1?.subject === e2?.subject &&
                    e1?.from === e2?.from &&
                    e1?.to === e2?.to &&
                    e1?.cc === e2?.cc
            )
        )
  }
  return (
    <div className="w-full h-full overflow-scroll">
      <FormPageHeader
        componentName="Factory Vendor"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        breadCrumbSeperator=">"
        currentPage={id ? "Update Factory Vendor" : "Add Factory Vendor"}
        parentBreadcrumbData={[
          { pageName: "Factory Vendor List", pageLink: "/factoryVendors" },
        ]}
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        hideDelete={hideDelete}
        handleCancel={handleCancel}
        saveDisable={!matchTwoArray(emailRoutingData,savedEmailRouting)}
        hideButtons={hideButton}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab 
            label="Basic Info" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
          <Tab 
            label="Email" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
          {id && (
            <Tab 
              label="Discount" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
            />
          )}
        </Tabs>
      </FormPageHeader>
      <div
        className="p-16 sm:p-24 overflow-scroll"
        style={{ height: tabValue === 1 ?"Calc(100% - 145px)":"Calc(100% - 140px - 50px)" }}
      >
        <div className={tabValue !== 0 ? "hidden" : " max-w-3xl"}>
          <label>*Vendor Number</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            disabled
            name="vendorNumber"
            value={vendorData.vendorNumber}
            error={
              (checksubmit && !vendorData?.vendorNumber) ||
              validError.vendorData?.vendorNumber
                ? true
                : isNum
                ? false
                : true
            }
            helperText={
              checksubmit && !vendorData?.vendorNumber
                ? "This field is required"
                : isNum
                ? validError.vendorData?.vendorNumber
                : "Please enter only numeric values."
            }
            onChange={onChangeHandleInput}
            // disabled={id ? true : false}
           sx={id ? { 
              backgroundColor: 'action.disabledBackground',
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: (theme) => theme.palette.text.primary,
              }
            } : {}}
            InputLabelProps={{
              shrink: vendorData.vendorNumber ? true : false,
            }}
          />
          <label>*Vendor Name</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            name="name"
            value={vendorData.name}
            error={
              (checksubmit && !vendorData?.name) || validError.vendorData?.name
                ? true
                : false
            }
            helperText={
              checksubmit && !vendorData?.name
                ? "This field is required"
                : validError.vendorData?.name
            }
            onChange={onChangeHandleInput}
          />
          <label>*Short Key</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            name="shortKey"
            value={vendorData.shortKey}
            error={
              (checksubmit && !vendorData?.shortKey) ||
              validError.vendorData?.shortKey
                ? true
                : false
            }
            helperText={
              checksubmit && !vendorData?.shortKey
                ? "This field is required"
                : validError.vendorData?.shortKey
            }
            onChange={onChangeHandleInput}
          />
          <label>Address 1</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            name="address1"
            value={vendorData.address1}
            // error={(checksubmit && !vendorData?.address1) || validError.vendorData?.address1 ? true : false}
            // helperText={(checksubmit && !vendorData?.address1) ? "This field is required" : validError.vendorData?.address1}
            onChange={onChangeHandleInput}
          />
          <label>Address 2</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            name="address2"
            value={vendorData.address2}
            // error={(checksubmit && !vendorData?.address2) || validError.vendorData?.address2 ? true : false}
            // helperText={(checksubmit && !vendorData?.address2) ? "This field is required" : validError.vendorData?.address2}
            onChange={onChangeHandleInput}
          />
          <label>Country name</label>
          <Stack className="mb-16">
            <Select
              name="addcountryName"
              placeholder="Select Country"
              value={
                countryOptions &&
                vendorData?.country &&
                countryOptions.filter((obj) =>
                  vendorData?.country.includes(obj.value)
                )
              }
              onChange={changeHandlerCountry}
              className="select"
              classNamePrefix="select"
              options={countryOptions}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {e.icon}
                  <span style={{ marginLeft: 5 }}>{e.label}</span>
                </div>
              )}
              styles={customStyles(
                (checksubmit && !vendorData?.country) ||
                  validError.vendorData?.country
                  ? "none"
                  : "none"
              )}
              isClearable
            />
            {/* <Typography sx={{ color: 'red', fontSize: "1.2rem", padding: "5px 0px 0px 10px" }}>{(checksubmit && !vendorData?.country) ? "This field is required" : validError.vendorData?.country}</Typography> */}
          </Stack>

          <label>City name</label>
          <Stack className="mb-16">
            <Select
              name="addcitiName"
              placeholder="Select City"
              value={
                citiOptions &&
                vendorData?.city &&
                citiOptions.filter((obj) =>
                  vendorData?.city.includes(obj.value)
                )
              }
              onChange={changeHandlerCity}
              className="select"
              classNamePrefix="select"
              options={citiOptions}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {e.value}
                </div>
              )}
              styles={customStyles(
                (checksubmit && !vendorData?.city) ||
                  validError.vendorData?.city
                  ? "none"
                  : "none"
              )}
              isClearable
            />
          </Stack>

          <label>Currency Code</label>
          <TextField
            className="mt-8 mb-16"
            required
            variant="outlined"
            fullWidth
            name="currencyCode"
            value={"EUR"}
            disabled={true}
            sx={{ 
              backgroundColor: 'action.disabledBackground',
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: (theme) => theme.palette.text.primary,
              }
            }}
            // value={vendorData.currencyCode}
            // error={(checksubmit && !vendorData?.currencyCode) || validError.vendorData?.currencyCode ? true : false}
            // helperText={(checksubmit && !vendorData?.currencyCode) ? "This field is required" : validError.vendorData?.currencyCode}
            onChange={onChangeHandleInput}
          />
          <FormControlLabel
            value={vendorData.active}
            name="active"
            control={<Switch />}
            label="Active"
            labelPlacement="start"
            onChange={onChangeHandleInput}
            checked={vendorData.active ? true : false}
          />
        </div>
        <div className={tabValue !== 1 ? "hidden" : " max-w-full"}>
          <Button
            className="mb-10 float-right"
            variant="contained"
            color="secondary"
            disabled={selectedEmailRows.length <= 0}
            onClick={async () => {
              if (
                emailRoutingData?.some(
                  (obj) =>
                    obj.emailRouting === "" ||
                    obj.emailRouting === null ||
                    obj.from === "" ||
                    obj.from === null ||
                    obj.to === "" ||
                    obj.to === null ||
                    obj.to === [] ||
                    obj.cc === "" ||
                    obj.cc === null ||
                    obj.cc === [] ||
                    obj.subject === "" ||
                    obj.subject === null
                )
              ) {
                const routing = emailRoutingData.filter(
                    (item) =>
                        !selectedEmailRows.some((ftItem) => ftItem.id === item.id)
                );
                setEmailRoutingData(routing);
                setSavedEmailRouting(routing)
                setSelectedEmailRows([]);
              } else {
                const routing = emailRoutingData.filter(
                    (item) =>
                        !selectedEmailRows.some((ftItem) => ftItem.id === item.id)
                );
                let model = {
                  emailRoutings: routing,
                };
                setEmailRoutingData(routing);
                setSavedEmailRouting(routing)
                try {
                  await OAuthService.updateData(url, params.id, model);
                  setSelectedEmailRows([]);
                  toast.success("Routing deleted successfully");
                } catch (error) {
                  setError(error.message);
                }
              }
            }}
          >
            <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
          </Button>
          <Button
            className="mb-10 mr-10 float-right"
            variant="contained"
            color="secondary"
            disabled={matchTwoArray(emailRoutingData,savedEmailRouting) || emailRoutingData?.some(
                (obj) =>
                    obj.emailRouting === "" ||
                    obj.emailRouting === null ||
                    obj.from === "" ||
                    obj.from === null ||
                    obj.to === "" ||
                    obj.to === null ||
                    obj.to === [] ||
                    obj.cc === "" ||
                    obj.cc === null ||
                    obj.cc === [] ||
                    obj.subject === "" ||
                    obj.subject === null
            )}
            onClick={async () => {
              if (
                emailRoutingData === undefined ||
                emailRoutingData?.length === 0
              ) {
                toast.error("Please add atleast one routing");
              } else {
                if (
                  emailRoutingData?.some(
                    (obj) =>
                      obj.emailRouting === "" ||
                      obj.emailRouting === null ||
                      obj.from === "" ||
                      obj.from === null ||
                      obj.to === "" ||
                      obj.to === null ||
                      obj.to === [] ||
                      obj.cc === "" ||
                      obj.cc === null ||
                      obj.cc === [] ||
                      obj.subject === "" ||
                      obj.subject === null
                  )
                ) {
                  toast.error("Please fill all the fields");
                } else {
                  let model = {
                    emailRoutings: emailRoutingData,
                  };
                  if (emailRoutingData?.length === 0) {
                    toast.error("Please add atleast one routing");
                  } else {
                    if (
                      emailRoutingData?.some(
                        (obj) =>
                          obj.emailRouting === "" ||
                          obj.emailRouting === null ||
                          obj.from === "" ||
                          obj.from === null ||
                          obj.to === "" ||
                          obj.to === null ||
                          obj.to === [] ||
                          obj.cc === "" ||
                          obj.cc === null ||
                          obj.cc === [] ||
                          obj.subject === "" ||
                          obj.subject === null
                      )
                    ) {
                      toast.error("Please fill all the fields");
                    } else {
                      if (location.pathname.includes("addVendor")) {
                        try {
                          await OAuthService.updateData(url,vendorData.vendorNumber, model);
                          toast.success("Routing Create successfully");
                        } catch (error) {
                          setError(error.message);
                        }
                      } else {
                        try {
                          await OAuthService.updateData(url, params.id, model);
                          toast.success("Routing saved successfully");
                          setSavedEmailRouting(emailRoutingData)
                        } catch (error) {
                          setError(error.message);
                        }
                      }
                    }
                  }
                }
              }
            }}
          >
            <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
          </Button>
          <Button
            className="mb-10 mr-10 float-right"
            variant="contained"
            color="secondary"
            disabled={selectedEmailRows?.length > 0}
            onClick={() => {
              setEmailRoutingData((pre) =>
                pre
                  ? [
                      ...pre,
                      {
                        id:
                          pre[pre?.length - 1]?.id === undefined
                            ? pre?.length + 1
                            : pre[pre?.length - 1]?.id + 1,
                        emailRouting: "",
                        from: "",
                        to: "",
                        cc: "",
                      },
                    ]
                  : [
                      {
                        id: 0,
                        emailRouting: "",
                        from: "",
                        to: "",
                        cc: "",
                      },
                    ]
              );
            }}
          >
            Add Routing
          </Button>
          <Stack style={{ height: "590px", width: "100%" }}>
            <AgGridTable
              columnDefs={column}
              gridRef={gridRef}
              rowData={emailRoutingData}
              // rowSelection={"single"}
              onSelectionChanged={onEmailSelectionChanged}
            />
          </Stack>

          {/*<Box sx={{ display: "flex", justifyContent: "space-between" }} >*/}
          {/*    <Stack>*/}
          {/*        <label>*BR Mail Subject</label>*/}
          {/*        <TextField*/}
          {/*            className="mt-8 mb-16"*/}
          {/*            required*/}
          {/*            variant="outlined"*/}
          {/*            fullWidth*/}
          {/*            name='brMailSubject'*/}
          {/*            value={vendorData.brMailSubject}*/}
          {/*            error={(checksubmit && !vendorData?.brMailSubject) || validError.vendorData?.brMailSubject ? true : false}*/}
          {/*            helperText={(checksubmit && !vendorData?.brMailSubject) ? "This field is required" : validError.vendorData?.brMailFrom}*/}
          {/*            onChange={onChangeHandleInput}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack>*/}
          {/*        <label>*BR Mail FROM</label>*/}
          {/*        <TextField*/}
          {/*            className="mt-8 mb-16"*/}
          {/*            required*/}
          {/*            variant="outlined"*/}
          {/*            fullWidth*/}
          {/*            name='brMailFrom'*/}
          {/*            value={vendorData.brMailFrom}*/}
          {/*            error={(checksubmit && !vendorData?.brMailFrom) || validError.vendorData?.brMailFrom ? true : isBrFrom ? false : true}*/}
          {/*            helperText={(checksubmit && !vendorData?.brMailFrom) ? "This field is required" : isBrFrom ? validError.vendorData?.brMailFrom : "Please enter valid email"}*/}
          {/*            onChange={onChangeHandleInput}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack sx={{ width: '24%' }}>*/}
          {/*        <label>*BR Mail TO</label>*/}
          {/*        <Autocomplete*/}
          {/*            freeSolo*/}
          {/*            disableClearable*/}
          {/*            multiple={true}*/}
          {/*            value={vendorData?.brMailTo}*/}
          {/*            options={userLists}*/}
          {/*            onChange={(event, newValue) => {*/}
          {/*                if (typeof newValue === 'string') {*/}
          {/*                    setVendorData({ ...vendorData, brMailTo: newValue })*/}
          {/*                } else if (newValue && newValue.inputValue) {*/}
          {/*                    setVendorData({ ...vendorData, brMailTo: newValue.inputValue })*/}
          {/*                } else {*/}
          {/*                    let external = [];*/}
          {/*                    let newArray = newValue.map((val) => {*/}
          {/*                        if (val.includes('Add ')) {*/}
          {/*                            let newVal = val.replace('Add ', '');*/}
          {/*                            if (newVal.includes(',')) {*/}
          {/*                                const array = newVal.split(",");*/}
          {/*                                array.map((arr, index) => {*/}
          {/*                                    if (index === 0) {*/}
          {/*                                        val = arr;*/}
          {/*                                    } else {*/}
          {/*                                        external.push(arr)*/}
          {/*                                    }*/}
          {/*                                })*/}
          {/*                            } else {*/}
          {/*                                val = newVal*/}
          {/*                            }*/}

          {/*                        } else if (val.includes(',')) {*/}
          {/*                            const array = val.split(",");*/}
          {/*                            array.map((arr, index) => {*/}
          {/*                                if (index === 0) {*/}
          {/*                                    val = arr;*/}
          {/*                                } else {*/}
          {/*                                    external.push(arr)*/}
          {/*                                }*/}
          {/*                            })*/}
          {/*                        }*/}
          {/*                        return val;*/}
          {/*                    })*/}
          {/*                    newArray = [...newArray, ...external];*/}
          {/*                    setVendorData({ ...vendorData, brMailTo: newArray })*/}
          {/*                }*/}
          {/*            }}*/}
          {/*            filterOptions={(options, params) => {*/}
          {/*                const filtered = filter(options, params);*/}

          {/*                const { inputValue } = params;*/}
          {/*                // Suggest the creation of a new value*/}
          {/*                const isExisting = options.some((option) => inputValue === option.title);*/}
          {/*                if (inputValue !== '' && !isExisting) {*/}
          {/*                    filtered.push(`Add ${inputValue}`);*/}
          {/*                }*/}

          {/*                return filtered;*/}
          {/*            }}*/}
          {/*            // renderTags={(value, getTagProps) =>{*/}
          {/*            //    return  value && value?.map((option, index) => (*/}
          {/*            //         <>*/}
          {/*            //             {(index === 0) ? <span className='p-4'>{option}</span> : <span className='p-4'>,{option}</span>}*/}
          {/*            //         </>*/}
          {/*            //     ))*/}
          {/*            // }*/}
          {/*            // }*/}
          {/*            renderInput={(params) => (*/}
          {/*                <TextField*/}
          {/*                    {...params}*/}
          {/*                    className="mt-8 mb-16"*/}
          {/*                    required*/}
          {/*                    variant="outlined"*/}
          {/*                    // fullWidth*/}
          {/*                    name='brMailTo'*/}
          {/*                    error={(checksubmit && !vendorData?.brMailTo) || validError.vendorData?.brMailTo ? true : isBrTo ? false : true}*/}
          {/*                    helperText={(checksubmit && !vendorData?.brMailTo) ? "This field is required" : isBrTo ? validError.vendorData?.brMailTo : "Please enter valid email"}*/}

          {/*                />*/}
          {/*            )}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack sx={{ width: '24%' }}>*/}
          {/*        <label>*BR Mail CC</label>*/}
          {/*        <Autocomplete*/}
          {/*            freeSolo*/}
          {/*            disableClearable*/}
          {/*            multiple={true}*/}
          {/*            value={vendorData?.brMailCc}*/}
          {/*            options={userLists}*/}
          {/*            onChange={(event, newValue) => {*/}
          {/*                if (typeof newValue === 'string') {*/}
          {/*                    setVendorData({ ...vendorData, brMailCc: newValue })*/}
          {/*                } else if (newValue && newValue.inputValue) {*/}
          {/*                    setVendorData({ ...vendorData, brMailCc: newValue.inputValue })*/}
          {/*                } else {*/}
          {/*                    let external = [];*/}
          {/*                    let newArray = newValue.map((val) => {*/}
          {/*                        if (val.includes('Add ')) {*/}
          {/*                            let newVal = val.replace('Add ', '');*/}
          {/*                            if (newVal.includes(',')) {*/}
          {/*                                const array = newVal.split(",");*/}
          {/*                                array.map((arr, index) => {*/}
          {/*                                    if (index === 0) {*/}
          {/*                                        val = arr;*/}
          {/*                                    } else {*/}
          {/*                                        external.push(arr)*/}
          {/*                                    }*/}
          {/*                                })*/}
          {/*                            } else {*/}
          {/*                                val = newVal*/}
          {/*                            }*/}

          {/*                        } else if (val.includes(',')) {*/}
          {/*                            const array = val.split(",");*/}
          {/*                            array.map((arr, index) => {*/}
          {/*                                if (index === 0) {*/}
          {/*                                    val = arr;*/}
          {/*                                } else {*/}
          {/*                                    external.push(arr)*/}
          {/*                                }*/}
          {/*                            })*/}
          {/*                        }*/}
          {/*                        return val;*/}
          {/*                    })*/}
          {/*                    newArray = [...newArray, ...external];*/}
          {/*                    setVendorData({ ...vendorData, brMailCc: newArray })*/}
          {/*                }*/}
          {/*            }}*/}
          {/*            filterOptions={(options, params) => {*/}
          {/*                const filtered = filter(options, params);*/}

          {/*                const { inputValue } = params;*/}
          {/*                // Suggest the creation of a new value*/}
          {/*                const isExisting = options.some((option) => inputValue === option.title);*/}
          {/*                if (inputValue !== '' && !isExisting) {*/}
          {/*                    filtered.push(`Add ${inputValue}`);*/}
          {/*                }*/}

          {/*                return filtered;*/}
          {/*            }}*/}
          {/*            renderInput={(params) => (*/}
          {/*                <TextField*/}
          {/*                    {...params}*/}
          {/*                    className="mt-8 mb-16"*/}
          {/*                    required*/}
          {/*                    variant="outlined"*/}
          {/*                    // fullWidth*/}
          {/*                    name='brMailCc'*/}
          {/*                    // value={vendorData.brMailCc}*/}
          {/*                    error={(checksubmit && !vendorData?.brMailCc) || validError.vendorData?.brMailCc ? true : isBrCc ? false : true}*/}
          {/*                    helperText={(checksubmit && !vendorData?.brMailCc) ? "This field is required" : isBrCc ? validError.vendorData?.brMailCc : "Please enter valid email"}*/}

          {/*                />*/}
          {/*            )}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*</Box>*/}
          {/*<Box sx={{ display: "flex", justifyContent: "space-between" }} >*/}
          {/*    <Stack>*/}
          {/*        <label>*RR Mail Subject</label>*/}
          {/*        <TextField*/}
          {/*            className="mt-8 mb-16"*/}
          {/*            required*/}
          {/*            variant="outlined"*/}
          {/*            fullWidth*/}
          {/*            name='rrMailSubject'*/}
          {/*            value={vendorData.rrMailSubject}*/}
          {/*            error={(checksubmit && !vendorData?.rrMailSubject) || validError.vendorData?.rrMailSubject ? true : false}*/}
          {/*            helperText={(checksubmit && !vendorData?.rrMailSubject) ? "This field is required" : validError.vendorData?.rrMailFrom}*/}
          {/*            onChange={onChangeHandleInput}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack>*/}
          {/*        <label>*RR Mail FROM</label>*/}
          {/*        <TextField*/}
          {/*            className="mt-8 mb-16"*/}
          {/*            required*/}
          {/*            variant="outlined"*/}
          {/*            // fullWidth*/}
          {/*            name='rrMailFrom'*/}
          {/*            value={vendorData.rrMailFrom}*/}
          {/*            error={(checksubmit && !vendorData?.rrMailFrom) || validError.vendorData?.rrMailFrom ? true : isRrFrom ? false : true}*/}
          {/*            helperText={(checksubmit && !vendorData?.rrMailFrom) ? "This field is required" : isRrFrom ? validError.vendorData?.rrMailFrom : "Please enter valid email"}*/}
          {/*            onChange={onChangeHandleInput}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack sx={{ width: '24%' }}>*/}
          {/*        <label>*RR Mail TO</label>*/}
          {/*        <Autocomplete*/}
          {/*            freeSolo*/}
          {/*            disableClearable*/}
          {/*            multiple={true}*/}
          {/*            value={vendorData?.rrMailTo}*/}
          {/*            options={userLists}*/}
          {/*            onChange={(event, newValue) => {*/}
          {/*                if (typeof newValue === 'string') {*/}
          {/*                    setVendorData({ ...vendorData, rrMailTo: newValue })*/}
          {/*                } else if (newValue && newValue.inputValue) {*/}
          {/*                    setVendorData({ ...vendorData, rrMailTo: newValue.inputValue })*/}
          {/*                } else {*/}
          {/*                    let external = [];*/}
          {/*                    let newArray = newValue.map((val) => {*/}
          {/*                        if (val.includes('Add ')) {*/}
          {/*                            let newVal = val.replace('Add ', '');*/}
          {/*                            if (newVal.includes(',')) {*/}
          {/*                                const array = newVal.split(",");*/}
          {/*                                array.map((arr, index) => {*/}
          {/*                                    if (index === 0) {*/}
          {/*                                        val = arr;*/}
          {/*                                    } else {*/}
          {/*                                        external.push(arr)*/}
          {/*                                    }*/}
          {/*                                })*/}
          {/*                            } else {*/}
          {/*                                val = newVal*/}
          {/*                            }*/}

          {/*                        } else if (val.includes(',')) {*/}
          {/*                            const array = val.split(",");*/}
          {/*                            array.map((arr, index) => {*/}
          {/*                                if (index === 0) {*/}
          {/*                                    val = arr;*/}
          {/*                                } else {*/}
          {/*                                    external.push(arr)*/}
          {/*                                }*/}
          {/*                            })*/}
          {/*                        }*/}
          {/*                        return val;*/}
          {/*                    })*/}
          {/*                    newArray = [...newArray, ...external];*/}
          {/*                    setVendorData({ ...vendorData, rrMailTo: newArray })*/}
          {/*                }*/}
          {/*            }}*/}
          {/*            filterOptions={(options, params) => {*/}
          {/*                const filtered = filter(options, params);*/}

          {/*                const { inputValue } = params;*/}
          {/*                // Suggest the creation of a new value*/}
          {/*                const isExisting = options.some((option) => inputValue === option.title);*/}
          {/*                if (inputValue !== '' && !isExisting) {*/}
          {/*                    filtered.push(`Add ${inputValue}`);*/}
          {/*                }*/}

          {/*                return filtered;*/}
          {/*            }}*/}
          {/*            renderInput={(params) => (*/}
          {/*                <TextField*/}
          {/*                    {...params}*/}
          {/*                    className="mt-8 mb-16"*/}
          {/*                    required*/}
          {/*                    variant="outlined"*/}
          {/*                    // fullWidth*/}
          {/*                    name='rrMailTo'*/}
          {/*                    // value={vendorData.rrMailTo}*/}
          {/*                    error={(checksubmit && !vendorData?.rrMailTo) || validError.vendorData?.rrMailTo ? true : isRrTo ? false : true}*/}
          {/*                    helperText={(checksubmit && !vendorData?.rrMailTo) ? "This field is required" : isRrTo ? validError.vendorData?.rrMailTo : "Please enter valid email"}*/}

          {/*                />*/}
          {/*            )}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*    <Stack sx={{ width: '24%' }}>*/}
          {/*        <label>*RR Mail CC</label>*/}
          {/*        <Autocomplete*/}
          {/*            freeSolo*/}
          {/*            disableClearable*/}
          {/*            multiple={true}*/}
          {/*            value={vendorData?.rrMailCc}*/}
          {/*            options={userLists}*/}
          {/*            onChange={(event, newValue) => {*/}
          {/*                if (typeof newValue === 'string') {*/}
          {/*                    setVendorData({ ...vendorData, rrMailCc: newValue })*/}
          {/*                } else if (newValue && newValue.inputValue) {*/}
          {/*                    setVendorData({ ...vendorData, rrMailCc: newValue.inputValue })*/}
          {/*                } else {*/}
          {/*                    let external = [];*/}
          {/*                    let newArray = newValue.map((val) => {*/}
          {/*                        if (val.includes('Add ')) {*/}
          {/*                            let newVal = val.replace('Add ', '');*/}
          {/*                            if (newVal.includes(',')) {*/}
          {/*                                const array = newVal.split(",");*/}
          {/*                                array.map((arr, index) => {*/}
          {/*                                    if (index === 0) {*/}
          {/*                                        val = arr;*/}
          {/*                                    } else {*/}
          {/*                                        external.push(arr)*/}
          {/*                                    }*/}
          {/*                                })*/}
          {/*                            } else {*/}
          {/*                                val = newVal*/}
          {/*                            }*/}

          {/*                        } else if (val.includes(',')) {*/}
          {/*                            const array = val.split(",");*/}
          {/*                            array.map((arr, index) => {*/}
          {/*                                if (index === 0) {*/}
          {/*                                    val = arr;*/}
          {/*                                } else {*/}
          {/*                                    external.push(arr)*/}
          {/*                                }*/}
          {/*                            })*/}
          {/*                        }*/}
          {/*                        return val;*/}
          {/*                    })*/}
          {/*                    newArray = [...newArray, ...external];*/}
          {/*                    setVendorData({ ...vendorData, rrMailCc: newArray })*/}
          {/*                }*/}
          {/*            }}*/}
          {/*            filterOptions={(options, params) => {*/}
          {/*                const filtered = filter(options, params);*/}

          {/*                const { inputValue } = params;*/}
          {/*                // Suggest the creation of a new value*/}
          {/*                const isExisting = options.some((option) => inputValue === option.title);*/}
          {/*                if (inputValue !== '' && !isExisting) {*/}
          {/*                    filtered.push(`Add ${inputValue}`);*/}
          {/*                }*/}

          {/*                return filtered;*/}
          {/*            }}*/}
          {/*            renderInput={(params) => (*/}
          {/*                <TextField*/}
          {/*                    {...params}*/}
          {/*                    className="mt-8 mb-16"*/}
          {/*                    required*/}
          {/*                    variant="outlined"*/}
          {/*                    // fullWidth*/}
          {/*                    name='rrMailCc'*/}
          {/*                    // value={vendorData.rrMailCc}*/}
          {/*                    error={(checksubmit && !vendorData?.rrMailCc) || validError.vendorData?.rrMailCc ? true : isRrCc ? false : true}*/}
          {/*                    helperText={(checksubmit && !vendorData?.rrMailCc) ? "This field is required" : isRrCc ? validError.vendorData?.rrMailCc : "Please enter valid email"}*/}

          {/*                />*/}
          {/*            )}*/}
          {/*        />*/}
          {/*    </Stack>*/}
          {/*</Box>*/}
        </div>
        <div className={tabValue !== 2 ? "hidden" : "h-full"}>
          {id && (
            <VendorDiscountData
              vendId={id}
              vendName={vendorData.name}
              setAllSuccessMsg={setAllSuccessMsg}
              setAllErrorMsg={setAllErrorMsg}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FactoryVendorForm;
